<template>
	<ui-modal @toggle="$emit('toggle')">
		<div class="flex flex-col gap-2" v-if="!loading">
			<ui-title textSize="big" textPosition="left" class="text-slate-700">
				<template v-slot:text>
					<p>Filtres</p>
				</template>
			</ui-title>
			<!-- NAME -->
			<form @submit.prevent="doSearch" class="flex flex-col gap-2">
				<form-input placeholder="Prénom, NOM" v-model="form.name" @keyup.enter="doSearch"></form-input>
				<!-- EMAIL -->
				<form-input placeholder="e-mail" v-model="form.email" @keyup.enter="doSearch"></form-input>
				<!-- PHONE -->
				<form-input placeholder="Téléphone" v-model="form.phone" @keyup.enter="doSearch"></form-input>
				<ui-button type="submit" @click="doSearch" class="mt-3 font-bold border-2" position="center">
					<template v-slot:text>Rechercher</template>
				</ui-button>
			</form>
		</div>
		<div v-else class="h-full w-full flex items-center justify-center text-2xl">
			<i class="fas fa-circle-notch fa-spin"></i>
		</div>
	</ui-modal>
</template>

<script setup>
	import { ref, onMounted } from 'vue';
	import { router } from '@inertiajs/vue3';

	const emit = defineEmits(['toggle']);

	const props = defineProps({
		searchForm: {
			type: Object,
			default: () => ({}),
		},
	});

	const loading = ref(false);
	const searchResult = ref([]);
	const types = ref([]);

	const form = ref({
		name: null,
		email: null,
		phone: null,
	});

	const doSearch = () => {
		router.get(route('admin.users.index'), {
			params: form.value,
		});
	};

	onMounted(() => {
		if (props.searchForm) {
			form.value = { ...props.searchForm };
		}
	});
</script>
